import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: -25,
    right: 0,
    zIndex: 1,
    pointerEvents: 'none'
  },
  illustration: {
    height: 'auto',
    opacity: 0.8
  }
}))
